import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import OutlineChevronDown from 'Components/Atoms/OutlineIcons/OutlineChevronDown';
import CollapseContent from './CollapseContent';
import { useState, forwardRef, useImperativeHandle } from 'react';
import { cn } from 'Utils/cn';

const Collapse = forwardRef(function Collapse(props, ref) {
    const { title, children, className, classes = {}, defaultOpen = false } = props;

    const [isOpen, setIsOpen] = useState(defaultOpen);

    useImperativeHandle(ref, () => ({
        open: () => setIsOpen(true),
        close: () => setIsOpen(false),
    }));

    return (
        <div className={cn(`w-full min-w-0`, className)}>
            <button
                className={cn(
                    'w-full inline-flex justify-start items-center px-0 py-2 gap-1.5 font-medium text-gray-800 text-sm',
                    classes.trigger,
                )}
                onClick={() => setIsOpen((open) => !open)}
                aria-expanded={isOpen}
            >
                <span>{title}</span>

                <motion.span animate={{ rotate: isOpen ? 180 : 0 }} className={cn('text-gray-500', classes.icon)}>
                    <OutlineChevronDown size={20} color="currentColor" />
                </motion.span>
            </button>

            <CollapseContent open={isOpen}>
                <div className={cn('py-2 min-w-0', classes.content)}>{children}</div>
            </CollapseContent>
        </div>
    );
});

export default Collapse;

Collapse.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    defaultOpen: PropTypes.bool,
    className: PropTypes.string,
    classes: PropTypes.shape({
        trigger: PropTypes.string,
        content: PropTypes.string,
        icon: PropTypes.string,
    }),
};
